import { getRankedComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function RankingSection() {
  const rankedComics = getRankedComics(10);

  const top3 = rankedComics.slice(0, 3);
  const rest = rankedComics.slice(3);

  return (
    <section id="ranking" className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            评分最高的韩漫作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8" data-product-shop>
          {top3.map((comic, index) => (
            <div key={comic.id} className="relative">
              <div className="absolute -top-3 left-4 z-10">
                <span className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-black text-lg ${
                  index === 0 ? 'bg-accent-500' : index === 1 ? 'bg-secondary-500' : 'bg-primary-500'
                }`}>
                  {index + 1}
                </span>
              </div>
              <ComicCard comic={comic} variant="horizontal" />
            </div>
          ))}
        </div>

        <div className="bg-background-50 rounded-xl p-4 md:p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {rest.map((comic, index) => (
              <ComicCard key={comic.id} comic={comic} variant="compact" rank={index + 4} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}